var _circle, _g, _circle2, _path, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddmembericonwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.47705,
    cy: 15,
    r: 2.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0126 20.4645C12.0749 19.5268 10.8031 19 9.47705 19C8.15097 19 6.8792 19.5268 5.94152 20.4645C5.00384 21.4021 4.47705 22.6739 4.47705 24L5.47705 24C5.47705 22.9391 5.89848 21.9217 6.64862 21.1716C7.39877 20.4214 8.41619 20 9.47705 20C10.5379 20 11.5553 20.4214 12.3055 21.1716L13.0126 20.4645Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 3.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9321 8H24.9142V10.5H22.3693V11.5H24.9142V14H25.9321V11.5H28.4771V10.5H25.9321V8Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 24C25 22.1435 24.2625 20.363 22.9497 19.0503C21.637 17.7375 19.8565 17 18 17C16.1435 17 14.363 17.7375 13.0503 19.0503C11.7375 20.363 11 22.1435 11 24L12.19 24C12.19 22.4591 12.8021 20.9813 13.8917 19.8917C14.9813 18.8021 16.4591 18.19 18 18.19C19.5409 18.19 21.0187 18.8021 22.1083 19.8917C23.1979 20.9813 23.81 22.4591 23.81 24H25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 5,
    fill: "white",
    transform: "translate(4.47705 19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 7,
    fill: "white",
    transform: "translate(9 17)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmembericonwhite);
export default __webpack_public_path__ + "static/media/addmembericonwhite.2c96a91fde0ed699e0b34b79bb1de068.svg";
export { ForwardRef as ReactComponent };